import * as React from 'react';
import { render } from 'react-dom';
import { Customizer } from 'office-ui-fabric-react';
import { ShellWithStore } from './ShellWithStore';
import { BrowserRouter } from 'react-router-dom';
import { ShellStyles } from '@employee-experience/shell/lib/Shell';
import { Header } from '@employee-experience/shell/lib/Header';
import { HeaderConfig } from './Configs/HeaderConfig';
import { Routes } from './Routes';
import { Menu } from './Pages/TAR/Menu/Menu';
import { AppFooter } from './Pages/TAR/Footer';
import * as Styled from './App.styles';
import { useLoginOnStartup } from '@employee-experience/common/lib/useLoginOnStartup';
import { Loading } from './Shared/Loading/Loading';
import { CoherenceCustomizations } from '@cseo/styles';

function App(): React.ReactElement {
    const headerConfig = HeaderConfig();
    useLoginOnStartup();
    const [user] = useLoginOnStartup();
    if (user === null) return <Loading label={'Logging in...'} />;
    return (
        <Customizer {...CoherenceCustomizations}>
            <ShellStyles />
            <BrowserRouter>
                <Header {...headerConfig} />
                <Menu />
                <Styled.Main id="main" tabIndex={-1}>
                    <Routes />
                </Styled.Main>
                <Styled.Footer>
                    <AppFooter />
                </Styled.Footer>
            </BrowserRouter>
        </Customizer>
    );
}

render(
    <ShellWithStore>
        <App />
    </ShellWithStore>,
    document.getElementById('app')
);
